const GET_REWARD_DETAILS = `
  query getRewardDetails($rewardID: ID!) {
    getReward(id: $rewardID) {
      id
      isDeleted
      approverType
      cost
      costType
      description
      imageName
      imageType
      isActive
      limitCount
      location
      name
      personLimit
      remainingCount
      rewardType
      validFrom
      validTo
      value
      valueType
      ownerType
      utid
      giftcardDisclaimer
      tangoAccountID
      missions {
        items {
          mission {
            name
            startDate
            endDate
          }
        }
      }
      users {
        items {
          id
          purchaseCount
          purchaseType
          status
          user {
            id
            imageName
            imageType
            name
            title
            initials
          }
          details {
            items {
              id
              purchaseCount
              purchaseType
              status
              createdAt
            }
          }
        }
      }
    }
  }
`;

export default GET_REWARD_DETAILS;
